import { MobileShell, cn } from '@pos/ui';
import { Boxes, House, Menu as MenuIcon, Package, ReceiptText } from 'lucide-react';
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useDashboard } from './data';

const TABS = [
  { key: 'home', path: '/home', label: 'Обзор', icon: <House /> },
  { key: 'sales', path: '/sales', label: 'Продажи', icon: <ReceiptText /> },
  { key: 'stock', path: '/stock', label: 'Склад', icon: <Boxes /> },
  { key: 'products', path: '/products', label: 'Товары', icon: <Package /> },
  { key: 'more', path: '/more', label: 'Ещё', icon: <MenuIcon /> },
];

/**
 * One phone screen. Top-level sections get the tab bar and a large title;
 * pushed screens (back button) get neither, so the task has the whole height.
 */
export function Screen({
  title,
  back,
  actions,
  children,
}: {
  title: ReactNode;
  /** Path to go back to; a pushed screen. */
  back?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const alerts = useDashboard().data?.alerts.length ?? 0;
  return (
    <MobileShell
      title={title}
      onBack={back ? () => navigate(back) : undefined}
      actions={actions}
      tabs={
        back
          ? undefined
          : TABS.map((t) => ({
              ...t,
              active: pathname.startsWith(t.path),
              badge: t.key === 'home' && alerts > 0 && !pathname.startsWith('/home') ? alerts : undefined,
              onSelect: () => navigate(t.path),
            }))
      }
    >
      {children}
    </MobileShell>
  );
}

/** Round header button (44 px target). */
export function HeaderButton({ label, onClick, children, className }: { label: string; onClick: () => void; children: ReactNode; className?: string }) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      className={cn('flex size-11 items-center justify-center rounded-full text-primary active:bg-rail [&_svg]:size-6', className)}
    >
      {children}
    </button>
  );
}
